/** Default authority leader used when the pasted record omits an LDR line. */
export var DEFAULT_AUTHORITY_LEADER = '00000nz  a2200000n  4500';
var LEADER_PREFIXES = new Set(['LDR', 'LEADER']);
var BLANK_INDICATOR_CHARS = new Set(['#', '_', '\\', ' ']);
var normaliseIndicator = function (ch) { return (ch === undefined || BLANK_INDICATOR_CHARS.has(ch) ? ' ' : ch); };
var isControlTag = function (tag) { return /^00\d$/.test(tag); };
/** Split the post-indicator remainder into subfields on the `$` delimiter. */
var parseSubfields = function (body) {
    var subfields = [];
    // Drop any text before the first `$` (lenient: stray indicator noise etc.).
    var firstDelimiter = body.indexOf('$');
    if (firstDelimiter === -1)
        return subfields;
    var chunks = body.slice(firstDelimiter + 1).split('$');
    for (var _i = 0, chunks_1 = chunks; _i < chunks_1.length; _i++) {
        var chunk = chunks_1[_i];
        if (chunk.length > 0) {
            subfields.push({ code: chunk.charAt(0), value: chunk.slice(1).trim() });
        }
    }
    return subfields;
};
/**
 * Parse a single non-empty content line into a `MarcField`, or return a string
 * describing why it could not be parsed.
 */
var parseLine = function (rawLine) {
    var line = rawLine.replace(/\$\$/g, '$');
    var match = line.match(/^(\S+)\s*(.*)$/);
    if (!match)
        return "nerozpoznan\u00FD \u0159\u00E1dek: \"".concat(rawLine, "\"");
    var tag = match[1];
    var rest = match[2];
    if (isControlTag(tag)) {
        return { tag: tag, data: rest.trim() };
    }
    if (!/^[0-9A-Za-z]{3}$/.test(tag)) {
        return "neplatn\u00FD tag \"".concat(tag, "\" (o\u010Dek\u00E1v\u00E1m 3 znaky nebo LDR)");
    }
    // Data field: leading `$` => both indicators blank; otherwise the two
    // characters after the tag are the indicators.
    var indicator1 = ' ';
    var indicator2 = ' ';
    var body = rest;
    if (!rest.startsWith('$')) {
        indicator1 = normaliseIndicator(rest.charAt(0));
        indicator2 = normaliseIndicator(rest.charAt(1));
        body = rest.slice(2);
    }
    var subfields = parseSubfields(body);
    if (subfields.length === 0) {
        return "pole ".concat(tag, " nem\u00E1 \u017E\u00E1dn\u00E9 podpole ($a ...)");
    }
    return {
        tag: tag,
        indicator1: indicator1,
        indicator2: indicator2,
        subfields: subfields,
    };
};
/**
 * Parse pasted mnemonic MARC text into a `MarcRecord`. Never throws — line-level
 * problems are accumulated in `errors` so the UI can show them alongside a
 * best-effort record.
 */
export var parseMarcText = function (text) {
    var errors = [];
    var fields = [];
    var leader = DEFAULT_AUTHORITY_LEADER;
    var lines = text.split(/\r?\n/);
    lines.forEach(function (rawLine, idx) {
        var trimmed = rawLine.trim();
        if (trimmed.length === 0)
            return;
        var firstToken = trimmed.split(/\s+/, 1)[0].toUpperCase();
        if (LEADER_PREFIXES.has(firstToken)) {
            leader = trimmed.slice(firstToken.length).trim() || DEFAULT_AUTHORITY_LEADER;
            return;
        }
        var parsed = parseLine(trimmed);
        if (typeof parsed === 'string') {
            errors.push("\u0158\u00E1dek ".concat(idx + 1, ": ").concat(parsed));
        }
        else {
            fields.push(parsed);
        }
    });
    return { record: { leader: leader, fields: fields }, errors: errors };
};
export default parseMarcText;
